module.exports = __webpack_public_path__ + "static/media/NotoSans-BoldItalic.e44b5d7b.woff2";